import { authHeader } from '../helpers/auth-header';
import { client } from './';
import { constants } from '../constants/calendar.constants'
//import BigCalendar from 'react-big-calendar'
import {
  Calendar as BigCalendar,
  DateLocalizer,
  momentLocalizer,
  globalizeLocalizer,
  move,
  Views as BigCalendarViews,
  Navigate,
  components,
} from 'react-big-calendar'


import moment from 'moment';
import { fromDateStr, toDateStr } from '../helpers/utcDate';

//const BigCalendarViews = BigCalendar.Views

export const calendarActions = {
	fetchRequests,
	changeWorkerCheck,
	changeWorkerAllCheck,
};

function changeWorkerCheck(idx, checked) {
	return (dispatch, getState) => {

		const r = getState().calendarStore.workers.slice()
		r[idx].checked = checked

		dispatch({
			type: constants.SET_WORKER_CHECKED,

			payload: new Promise((resolve, reject) => {
				resolve({r})
					})
			})
}}

function changeWorkerAllCheck(checked) {
	return (dispatch, getState) => {

		const r = getState().calendarStore.workers.slice()
		r.forEach(el=>{el.checked = checked}) 

		dispatch({
			type: constants.SET_WORKER_CHECKED,

			payload: new Promise((resolve, reject) => {
				resolve({r})
					})
			})
}}


function fetchRequests(view, date) {
	return (dispatch, getState) => {

		let date1 = moment(date)
		let date2 = moment(date)

		if (view === BigCalendarViews.MONTH) {
			date1.startOf('month')
			date1.startOf('week')
			date2.endOf('month')
			date2.endOf('week')
		}
		else if (view === BigCalendarViews.WEEK) {
			date1.startOf('week')
			date2.endOf('week')
		}

		const d1 = fromDateStr(date1)
		const d2 = toDateStr(date2)

		let rurl = `/request/get_tasks?FromDate=${d1}&Todate=${d2}`

		const p = getState().calendarStore.workers

		dispatch({
			type: constants.FETCH_REQUESTS,

			payload: new Promise((resolve, reject) => {
				client.get(rurl, { headers: authHeader() })
					.then(result => {
						const d = result.data
						//d && d.sort((a, b) => a.worker.fullName.localeCompare(b.worker.fullName));				
						const r = []
						const e = []
						d.forEach(el => {
							let i = r.findIndex(elr => elr.id === el.worker.id)
							if (i < 0) {
								r.push({ ...el.worker, checked: true, title: el.worker.fullName })
								i = r.length - 1
							}

							e.push({
								title: el.requestId + ' ' + el.worker.surName 
									+ (el.worker.firstName ? (' ' + el.worker.firstName.substring(0, 1) + '.') : '')
									+ (el.worker.patrName ? (' ' + el.worker.patrName.substring(0, 1) + '.') : ''),
									//start: new Date(el.fromDate.replace(/ /g,'T')),
									//end: new Date(el.toDate.replace(/ /g,'T')),
									start: new Date(el.fromDate),
									end: new Date(el.toDate),
										//resourceId: el.worker.id, 
								workerPos: i,
								requestId: el.requestId,
								allDay: false
							})
						})
						resolve({ 
							events: e, 
							resources: r, 
							range: {date1, date2} })
					})
					.catch(err => {
						console.log(err.response)
						reject(err);
					})
			})
		})
	}
}
